import { computed, inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';

import { UserStore } from '../auth/store/user.store';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  readonly #userStore = inject(UserStore);
  isSignedIn = computed(() => this.#userStore.signedIn());
  restricted = computed(() => this.#userStore.restricted());

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.#userStore.session(window.location.origin + state.url);
    return this.isSignedIn() && !this.restricted();
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(next, state);
  }
}
